package com.milta.feature.route.domain.entity

/**
 * Manager-facing team dashboard (MIL-38 — `GET /api/v1/routes`, Enterprise role only, defaults to
 * today). Replaces the former flat `List<Route>` shape returned by that same endpoint path: the
 * response is now a wrapper carrying day-level totals plus one summary per driver route.
 */
data class TeamRoutesOverview(
    /** Resolved date of this overview (yyyy-MM-dd) — echoes the request's `date` query param, or
     * today's date when omitted. */
    val date: String,
    val totalRoutes: Int,
    val totalDeliveries: Int,
    val completedDeliveries: Int,
    val routes: List<DriverRouteOverview>,
)

/** One driver's route as shown on the Manager's team dashboard for the requested day. */
data class DriverRouteOverview(
    val routeId: String,
    val driverId: String,
    val driverFirstName: String,
    val driverLastName: String,
    val status: RouteStatus,
    val startedAt: String?,
    val completedAt: String?,
    val completedStopsCount: Int,
    val totalStopsCount: Int,
) {
    val progress: Float get() = if (totalStopsCount == 0) 0f else completedStopsCount.toFloat() / totalStopsCount
}
